import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/illustrations/navigation-gruppets.webp")